import { useEffect } from 'react'
import { ensureFontLoaded } from 'lib/fontLoader'
import { CHAT_FONT_FAMILIES } from 'lib/chatFontCatalog'

export const APP_FONT_KEY = 'INTER'
export const APP_FONT_ATTRIBUTE = 'data-app-font'
export const APP_FONT_VALUE = 'inter'

const faceLoaded = (family: string): boolean => {
  if (typeof globalThis.document === 'undefined') return true
  const fonts = globalThis.document.fonts
  if (fonts == null || typeof fonts.forEach !== 'function') return true
  let loaded = false
  try {
    fonts.forEach((face) => {
      if (face.status === 'loaded' && face.family.replace(/["']/g, '') === family) loaded = true
    })
  } catch {
    return false
  }
  return loaded
}

export interface AppFontRoot {
  setAttribute: (name: string, value: string) => void
  removeAttribute: (name: string) => void
}

export const syncAppFont = (
  enabled: boolean,
  root: AppFontRoot | null
): (() => void) | undefined => {
  if (root == null) return
  if (!enabled) {
    root.removeAttribute(APP_FONT_ATTRIBUTE)
    return
  }
  let cancelled = false
  void ensureFontLoaded(APP_FONT_KEY).then(() => {
    if (cancelled) return
    if (faceLoaded(CHAT_FONT_FAMILIES[APP_FONT_KEY].family)) {
      root.setAttribute(APP_FONT_ATTRIBUTE, APP_FONT_VALUE)
    }
  })
  return () => { cancelled = true }
}

const documentRoot = (): AppFontRoot | null =>
  typeof globalThis.document === 'undefined' ? null : globalThis.document.documentElement

export const useAppFont = (enabled: boolean): void => {
  useEffect(() => syncAppFont(enabled, documentRoot()), [enabled])
}
